
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/help/customer-care/third-party",
      function () {
        return require("private-next-pages/help/customer-care/third-party/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/help/customer-care/third-party"])
      });
    }
  